import { render, staticRenderFns } from "./RemocaoEntradaSaida.vue?vue&type=template&id=44c54fba&"
import script from "./RemocaoEntradaSaida.vue?vue&type=script&lang=js&"
export * from "./RemocaoEntradaSaida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports